import { stateCity, activities, unity, stores } from '../../modules/select';
import { dateRange } from '../../modules/dateRange';
import { userSubscribe } from '../../modules/userSubscribe';

export const challengesSearch = () => {
  stateCity();
  activities();
  unity();
  stores();
  dateRange();
  userSubscribe();
};
